import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=08f98316"
import script from "./LeftSidebar.vue?vue&type=script&lang=ts"
export * from "./LeftSidebar.vue?vue&type=script&lang=ts"
import style0 from "../../../assets/style/sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports